import { commonColor } from "/@/utils/color";

// 任务类型
export enum TaskType {
  Immediate = 0, // 立即执行
  Single = 1, // 单次定时任务
  Repetitive = 2, // 重复定时
  Continuous = 3, // 连续执行
}

export const TaskTypeMap = {
  [TaskType.Immediate]: "立即",
  [TaskType.Single]: "定时",
  [TaskType.Repetitive]: "重复定时",
  [TaskType.Continuous]: "连续执行",
};

// 失控动作
export enum OutOfControlAction {
  ReturnToHome = 0,
  Hover = 1,
  Land = 2,
  Continues = 3,
}

export const OutOfControlActionMap = {
  [OutOfControlAction.ReturnToHome]: "返航",
  [OutOfControlAction.Hover]: "悬停",
  [OutOfControlAction.Land]: "降落",
  [OutOfControlAction.Continues]: "失控继续执行",
};

export const OutOfControlActionOptions = [
  {
    value: OutOfControlAction.ReturnToHome,
    label: OutOfControlActionMap[OutOfControlAction.ReturnToHome],
  },
  {
    value: OutOfControlAction.Hover,
    label: OutOfControlActionMap[OutOfControlAction.Hover],
  },
  {
    value: OutOfControlAction.Land,
    label: OutOfControlActionMap[OutOfControlAction.Land],
  },
  {
    value: OutOfControlAction.Continues,
    label: OutOfControlActionMap[OutOfControlAction.Continues],
  },
];
// 模板设置
export const sysType = [
  {
    name: "飞行控制默认参数",
    key: "fly_num",
  },
  {
    name: "环境任务默认参数",
    key: "warn_num",
  },
  {
    name: "地图中心点默认参数",
    key: "map_num",
  },
  {
    name: "网格颜色默认参数",
    key: "gird_color",
  },
  {
    name: "图片设置",
    key: "img_num",
  },
  {
    name: "红外温度预警设置",
    key: "infrared_sys",
  },
  {
    name: "大模型设置",
    key: "model_sys",
  },
  {
    name: "大屏展示规则",
    key: "rule_sys",
  },
  {
    name: "视频对比规则",
    key: "compare_rule",
  },
  {
    name: "气象监测设置",
    key: "monitor_sys",
  },
];
// 任务状态
export enum TaskStatus {
  Wait = 1, //  待执行
  Carrying = 2, // 执行中
  Success = 3, // 完成
  CanCel = 4, // 取消
  Fail = 5, // 失败
  Paused = 6, // 暂停
}

export const TaskStatusMap = {
  [TaskStatus.Wait]: "待执行",
  [TaskStatus.Carrying]: "执行中",
  [TaskStatus.Success]: "完成",
  [TaskStatus.CanCel]: "取消",
  [TaskStatus.Fail]: "失败",
  [TaskStatus.Paused]: "暂停",
};

export const TaskStatusColor = {
  [TaskStatus.Wait]: commonColor.BLUE,
  [TaskStatus.Carrying]: commonColor.BLUE,
  [TaskStatus.Success]: commonColor.NORMAL,
  [TaskStatus.CanCel]: commonColor.FAIL,
  [TaskStatus.Fail]: commonColor.FAIL,
  [TaskStatus.Paused]: commonColor.BLUE,
};

// 任务执行 ws 消息状态
export enum TaskProgressStatus {
  // Sent = '已下发', // 已下发
  // inProgress = '执行中', // 执行中
  // Paused = '暂停', // 暂停
  // Rejected = '拒绝', // 拒绝
  // Canceled = '取消或终止', // 取消或终止
  // Timeout = '超时', // 超时
  // Failed = '失败', // 失败
  // OK = '上传成功', // 上传成功
  Sent = "sent", // 已下发
  inProgress = "in_progress", // 执行中
  Paused = "paused", // 暂停
  Rejected = "rejected", // 拒绝
  Canceled = "canceled", // 取消或终止
  Timeout = "timeout", // 超时
  Failed = "failed", // 失败
  OK = "ok", // 上传成功
}

// 任务进度消息
export interface TaskProgressInfo {
  bid: string;
  output: {
    ext: {
      current_waypoint_index: number;
      media_count: number; // 媒体文件
    };
    progress: {
      current_step: number;
      percent: number;
    };
    status: TaskProgressStatus;
  };
  result: number;
}

// ws status => log status
export const TaskProgressWsStatusMap = {
  [TaskProgressStatus.Sent]: TaskStatus.Carrying,
  [TaskProgressStatus.inProgress]: TaskStatus.Carrying,
  [TaskProgressStatus.Rejected]: TaskStatus.Fail,
  [TaskProgressStatus.OK]: TaskStatus.Success,
  [TaskProgressStatus.Failed]: TaskStatus.Fail,
  [TaskProgressStatus.Canceled]: TaskStatus.CanCel,
  [TaskProgressStatus.Timeout]: TaskStatus.Fail,
  [TaskProgressStatus.Paused]: TaskStatus.Wait,
  [TaskProgressStatus.Paused]: TaskStatus.Paused,
};

// 根据媒体文件上传进度信息，前端自己判断出的状态
export enum MediaStatus { // 媒体上传进度
  ToUpload = 1, // 待上传
  Uploading = 2, // 上传中
  Empty = 3, // 无媒体文件
  Success = 4, // 上传成功
}

export const MediaStatusMap = {
  [MediaStatus.ToUpload]: "等待上传",
  [MediaStatus.Uploading]: "上传中...",
  [MediaStatus.Success]: "上传成功",
  [MediaStatus.Empty]: "暂无文件",
};

export const MediaStatusColorMap = {
  [MediaStatus.ToUpload]: commonColor.BLUE,
  [MediaStatus.Uploading]: commonColor.BLUE,
  [MediaStatus.Success]: commonColor.NORMAL,
  [MediaStatus.Empty]: commonColor.WARN,
};

// 媒体上传进度消息
export interface MediaStatusProgressInfo {
  job_id: string;
  media_count: number;
  uploaded_count: number;
}

// 媒体上传优先级消息
export interface TaskMediaHighestPriorityProgressInfo {
  pre_job_id: string;
  job_id: string;
}
